import type { Enrollment } from '@/types/domain';

/** The signed-in learner's enrollment state, keyed by course id. */
export const myEnrollments: Record<string, Enrollment> = {
  ipc: { courseId: 'ipc', progress: 50, attended: null, pretest: 70, posttest: null, eval: null, status: 'in-progress' },
  fire: { courseId: 'fire', progress: 0, attended: false, pretest: null, posttest: null, eval: null, status: 'enrolled' },
};
